<kt-portlet class="knostos-grid">
  <kt-portlet-header
    title="{{ 'MED_REVIEW.TITLE' | translate }}"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource.loading$"
  >
    <ng-container ktPortletTools>
      <button
        *ngIf="fromPatient"
        type="button"
        mat-raised-button
        [ngClass]="isCompleted ? 'btn btn-primary' : 'btn btn-light-primary'"
        matTooltip="Save Changes"
        (click)="showCompleted()"
      >
        <!--        Submit-->
        <!--      </button>-->
        <!--&lt;!&ndash;      <button&ndash;&gt;-->
        <!--&lt;!&ndash;        *ngIf="fromPatient"&ndash;&gt;-->
        <!--&lt;!&ndash;        type="button"&ndash;&gt;-->
        <!--&lt;!&ndash;        mat-raised-button&ndash;&gt;-->
        <!--&lt;!&ndash;        color="primary"&ndash;&gt;-->
        <!--&lt;!&ndash;        class="font-weight-normal mr-4"&ndash;&gt;-->
        <!--&lt;!&ndash;        (click)="showCompleted()"&ndash;&gt;-->
        <!--&lt;!&ndash;      >&ndash;&gt;-->
        {{ 'COMPLETED' | translate }}
      </button>
      <button
        *ngIf="!fromPatient"
        mat-raised-button
        type="button"
        class="btn btn-light-primary mr-4"
        (click)="manageConfigs($event)"
      >
        {{ 'MED_REVIEW.CONFIGS' | translate }}
      </button>
      <ng-template *ngIf="!fromPatient" ngxPermissionsOnly="canAssignStandard">
        <button
          type="button"
          mat-raised-button
          color="primary"
          class="font-weight-normal mr-4"
          (click)="assignStandard($event)"
        >
          {{ 'MED_REVIEW.ASSIGN_STANDARD' | translate }}
        </button>
      </ng-template>
      <kt-med-review-filter
        *ngIf="!fromPatient"
        [filter]="filter"
        (filterChange)="filterChanges($event)"
      ></kt-med-review-filter>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mat-table-wrapper">
      <mat-table
        [dataSource]="dataSource"
        class="mat-elevation-z8 med-review-table"
        matSort
        #sort="matSort"
        matSortActive="id"
      >
        <ng-container matColumnDef="id">
          <mat-header-cell
            class="mat-column"
            style="min-width: 100px"
            mat-sort-header
            *matHeaderCellDef
            >#</mat-header-cell
          >
          <mat-cell style="min-width: 100px" *matCellDef="let element">{{ element.id }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="patientId">
          <mat-header-cell
            class="mat-column"
            *matHeaderCellDef
            mat-sort-header
            style="max-width: 110px"
            >Patient ID</mat-header-cell
          >
          <mat-cell *matCellDef="let patient" style="max-width: 110px">{{
            patient?.patient_external_id
          }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="patientName">
          <mat-header-cell class="mat-column" mat-sort-header *matHeaderCellDef
            >{{ 'PATIENT.PATIENT_NAME' | translate }}
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element" class="gl-block">
            {{ element.patient_name }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="facilityName">
          <mat-header-cell class="mat-column" *matHeaderCellDef mat-sort-header>{{
            'FACILITY_NAME' | translate
          }}</mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{ element.facility_name }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="startDate">
          <mat-header-cell class="mat-column" *matHeaderCellDef mat-sort-header>{{
            'REVIEW_OPEN' | translate
          }}</mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element">
            {{ stringUtilsService.formatDate(element.start_date) }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="endDate">
          <mat-header-cell class="mat-column" *matHeaderCellDef mat-sort-header>
            {{ 'DONE_DATE' | translate }}
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element">
            {{ stringUtilsService.formatDate(element.done_date) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="time">
          <mat-header-cell class="mat-column" *matHeaderCellDef translate="TIME">{{
            'TIME' | translate
          }}</mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element">
            {{ stringUtilsService.formatDateDiff(element.start_date) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="facilityCycleDate">
          <mat-header-cell class="mat-column" mat-sort-header *matHeaderCellDef>{{
            'CYCLE_DATE' | translate
          }}</mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element">
            {{ stringUtilsService.formatDate(element.facility_cycle_date) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="indicators">
          <mat-header-cell
            class="mat-column"
            *matHeaderCellDef
            translate="INDICATORS"
          ></mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element">
            <div
              [innerHTML]="getIndicators(element.indicators) | safe : 'html'"
              class="indicators-cell"
            ></div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="officeId">
          <mat-header-cell class="mat-column" mat-sort-header *matHeaderCellDef
            >Office</mat-header-cell
          >
          <mat-cell mat-cell *matCellDef="let element">
            <div *ngIf="loadingOffices">
              {{ element.office_id | getOffice : offices }}
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="closedBy">
          <mat-header-cell class="mat-column" mat-sort-header *matHeaderCellDef>
            Closed By
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div>
              {{ userMap.get(element.closed_by_id) | getUserFullName }}
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef translate="ACTIONS"></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <ng-template *ngIf="isCompleted" ngxPermissionsOnly="accessMedReview">
              <button
                matTooltip="{{ 'MED_REVIEW.SNAPSHOT' | translate }}"
                class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
                (click)="displaySnapShots($event, element)"
              >
                <span inlineSVG="assets/media/svg/icons/General/visible-grey.svg"> </span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canAccessComments">
              <button
                matTooltip="{{ 'MED_REVIEW.COMMENTS' | translate }}"
                class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                (click)="displayComments($event, element)"
              >
                <i class="flaticon-comment"></i>
              </button>
            </ng-template>
            <button
              matTooltip="{{ 'MED_REVIEW.FOLLOWUPS' | translate }}"
              class="btn btn-icon btn-light btn-hover-warning btn-sm m-1"
              (click)="displayFollowups($event, element)"
            >
              <i class="flaticon-calendar-with-a-clock-time-tools"></i>
            </button>
          </mat-cell>
        </ng-container>
        <mat-header-row
          *matHeaderRowDef="displayedColumns"
          class="sticky-header-medreview"
        ></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          (dblclick)="!fromPatient && navicatToBoard(row)"
          class="cursor-pointer"
        ></mat-row>
      </mat-table>
      <div
        class="mat-table__message"
        *ngIf="!(dataSource.isPreloadTextViewed$ | async) && !dataSource.hasItems"
      >
        {{ 'TABLE.NO_RECORDS' | translate }}
      </div>
      <!-- Message for empty data  -->
      <div class="mat-table__message" *ngIf="dataSource.isPreloadTextViewed$ | async">
        {{ 'TABLE.PLAESE_WAIT' | translate }}
      </div>
    </div>

    <div class="mat-table__bottom">
      <mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
      <mat-paginator
        [pageSize]="10"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-body>
</kt-portlet>
